<script setup lang="ts">
import ArrivedQueueItem from "~/dto/queue/ArrivedQueueItem";

const { t } = useI18n();

defineProps({
  items: {
    type: Array as () => ArrivedQueueItem[],
    required: true
  }
});
</script>

<template>
  <template v-if="items.length > 0">
    <table class="table d-md-none">
      <thead>
        <tr>
          <th>#</th>
          <th>{{ t("components.queue_items_table.car_plate") }}</th>
          <th>{{ t("components.queue_items_table.arrive_date") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="item in items"
          :key="item.registrationNumber"
        >
          <td>{{ item.callingOrder }}</td>
          <td>
            {{ item.registrationNumber }}
            <span
              v-if="item.isInPriorityQueue"
              v-tooltip="t('components.queue_items_table.priority_title')"
            >
              <i class="cis-exclamation icon" />
            </span>
          </td>
          <td>{{ formatArrivedAt(item.registeredAt) }}</td>
        </tr>
      </tbody>
    </table>
    <div class="d-none d-md-grid queue-items-grid mb-3">
      <div
        v-for="item in items"
        :key="item.registrationNumber"
        class="queue-item-card border rounded p-2"
      >
        <div class="d-flex justify-content-between align-items-start gap-2">
          <span class="fw-semibold">{{ item.callingOrder }}</span>
          <span class="text-end">
            {{ item.registrationNumber }}
            <i
              v-if="item.isInPriorityQueue"
              v-tooltip="t('components.queue_items_table.priority_title')"
              class="cis-exclamation icon"
            />
          </span>
        </div>
        <div class="text-body-secondary small mt-1">
          {{ formatArrivedAt(item.registeredAt) }}
        </div>
      </div>
    </div>
  </template>
  <div
    v-else
    v-cloak
  >
    {{ t('components.queue_items_table.empty') }}
  </div>
</template>

<style scoped>
.queue-items-grid {
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 0.5rem;
}
</style>
